"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEOURLType = exports.Sort = exports.Brand = exports.EndecaPageType = exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["search"] = "search";
    PageType["browse"] = "browse";
    PageType["promo"] = "promo";
    PageType["valuedeal"] = "valuedeal";
})(PageType = exports.PageType || (exports.PageType = {}));
var EndecaPageType;
(function (EndecaPageType) {
    EndecaPageType["b"] = "browse";
    EndecaPageType["v"] = "valuedeal";
    EndecaPageType["q"] = "search";
    EndecaPageType["promo"] = "promo";
})(EndecaPageType = exports.EndecaPageType || (exports.EndecaPageType = {}));
var Brand;
(function (Brand) {
    Brand["very"] = "very";
    Brand["littlewoods"] = "littlewoods";
    Brand["veryireland"] = "veryireland";
})(Brand = exports.Brand || (exports.Brand = {}));
var Sort;
(function (Sort) {
    Sort["relevance"] = "relevance";
    Sort["brand"] = "brand";
    Sort["highestrated"] = "highestrated";
    Sort["newin"] = "newin";
    Sort["pricedesc"] = "pricedesc";
    Sort["price"] = "price";
})(Sort = exports.Sort || (exports.Sort = {}));
var SEOURLType;
(function (SEOURLType) {
    SEOURLType[SEOURLType["addFacet"] = 0] = "addFacet";
    SEOURLType[SEOURLType["removeFacet"] = 1] = "removeFacet";
    SEOURLType[SEOURLType["addCategory"] = 2] = "addCategory";
    SEOURLType[SEOURLType["clearAll"] = 3] = "clearAll";
})(SEOURLType = exports.SEOURLType || (exports.SEOURLType = {}));
